import { ErrorMessage } from 'components/Form'
import { useState, useEffect, FocusEventHandler } from 'react'
import { Box, Button, Flex, Label } from 'theme-ui'
import { NetSuiteRecord } from 'types'
import { SearchNetSuite } from './SearchNetSuite'

export type NetSuiteLinkProps = {
  netsuiteRecord?: NetSuiteRecord
  initialQuery?: string
  onSetNetsuiteRecord: (data: NetSuiteRecord) => void
  onUnlink: () => void
  onBlur?: FocusEventHandler
  errorMessage?: string
  tabIndex?: number
  disabled: boolean
}

export function NetSuiteLink({
  netsuiteRecord = undefined,
  initialQuery,
  onSetNetsuiteRecord,
  onUnlink,
  onBlur,
  tabIndex,
  errorMessage,
  disabled,
}: NetSuiteLinkProps) {
  const [fetchError, setFetchError] = useState<string>('')
  const [error, setError] = useState<string>('')
  useEffect(() => {
    if (fetchError) {
      setError(fetchError)
    } else if (errorMessage) {
      setError(errorMessage)
    } else {
      setError('')
    }
  }, [errorMessage, fetchError, setError])
  const handleLink = (data: NetSuiteRecord): void => {
    onSetNetsuiteRecord(data)
  }
  const handleUnlink = () => {
    onUnlink()
  }

  return (
    <>
      <Box data-cy="netsuite-link">
        {netsuiteRecord?.id ? (
          <Flex
            sx={{
              alignItems: 'center',
              justifyContent: 'start',
              pb: 4,
            }}>
            <Box>
              <Label sx={{}}>Student record from Netsuite</Label>
              <Box sx={{ fontSize: 2 }}>
                {netsuiteRecord.forename} {netsuiteRecord.surname}
              </Box>
            </Box>
            {!disabled ? (
              <Box>
                <Button
                  variant="buttons.white"
                  sx={{ position: 'relative' }}
                  type="button"
                  disabled={disabled}
                  onClick={handleUnlink}>
                  Change
                </Button>
              </Box>
            ) : (
              <Box></Box>
            )}
          </Flex>
        ) : (
          <SearchNetSuite
            initialQuery={initialQuery}
            onLink={handleLink}
            setError={setFetchError}
            onBlur={onBlur}
            disableNetSuite={disabled}
            tabIndex={tabIndex}
          />
        )}
      </Box>

      <ErrorMessage>{error && <span>{error}</span>}</ErrorMessage>
    </>
  )
}
